export default __webpack_public_path__ + "static/media/download.227cf914.svg";